"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.mergeReference = void 0;
var mergeReferenceInto_1 = require("../specification/draft-04/mergeReferenceInto");
var mergeReferenceInto_2 = require("../specification/draft-06/mergeReferenceInto");
var mergeReferenceInto_3 = require("../specification/draft-07/mergeReferenceInto");
var mergeReferenceInto_4 = require("../specification/draft-2020-12/mergeReferenceInto");
var mergeReferenceInto = function (metaSchemaURI) {
    switch (metaSchemaURI) {
        case 'http://json-schema.org/draft-04/schema#':
            return mergeReferenceInto_1.mergeReferenceInto;
        case 'http://json-schema.org/draft-06/schema#':
            return mergeReferenceInto_2.mergeReferenceInto;
        case 'http://json-schema.org/draft-07/schema#':
            return mergeReferenceInto_3.mergeReferenceInto;
        case 'https://json-schema.org/draft/2020-12/schema':
            return mergeReferenceInto_4.mergeReferenceInto;
        default:
            return mergeReferenceInto_4.mergeReferenceInto;
    }
};
function mergeReference(reference, info, dereferencedValue, referenceMergePolicy) {
    var $ref = reference.$ref, siblings = __rest(reference, ["$ref"]);
    var target = {};
    mergeReferenceInto(info.metadata.metaSchemaURI)(target, dereferencedValue, siblings, referenceMergePolicy);
    return target;
}
exports.mergeReference = mergeReference;
